












































































































































































































































































































































































































import {Component, Mixins, Vue, Watch} from "vue-property-decorator";

import CatalogMixin from '../mixins/CatalogMixin';
import {OnlineCounter} from "@mixins/OnlineCounter";
import AnalyticsMixin from "@mixins/AnalyticsMixin";

import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {UserRepository} from "@api/repositories/UserRepository";
import {MeetingRepository} from "@api/repositories/MeetingRepository";
import {FileRepository} from "@api/repositories/FileRepository";

import {GeneralCatalogItem} from '@api/models/GeneralCatalogItem';
import {PROFILE_FIELDS_BASIC, UserProfile} from "@api/models/UserProfile";
import {WebinarInfo} from "@api/models/WebinarInfo";
import {AppercodeFile} from "@api/models/File";
import { Element } from "@api/models/Element";

import Comments from "@share/comments/components/Comments.vue";
import ItemsList from "@share/common/ItemsList.vue";
import Speaker from '@share/session/components/Speaker.vue';
import Description from "@share/common/Description.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";
import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import TagList from "@share/common/tag-list/TagList.vue";
import ImageCard from "./PartnerCard.vue";
import WebConference from "@share/web-conferences/WebConference.vue";
import PeopleManagement from "@share/web-conferences/components/people/PeopleManagement.vue";
import FileUploadPlaceholder from "./FileUploadPlaceholder.vue";
import TextFieldPlaceholder from "./TextFieldPlaceholder.vue";
import VideoPlaceholder from "./VideoPlaceholder.vue";
import ParticipantsPlaceholder from "./ParticipantsPlaceholder.vue";
import Analytics from "./Analytics.vue";

import {DateTime} from "luxon";
import CheckSvg from '../../../assets/svg/check.svg'
import LiveSvg from '../../../assets/svg/live.svg';
import PlayBtn from '../../../assets/svg/play_session_placeholder.svg';
import FileSvg from '../../../assets/svg/file.svg';
import PdfSvg from '../../../assets/svg/pdf.svg';
import LinkedinSvg from '../../../assets/svg/linkedin.svg';
import FacebookSvg from '../../../assets/svg/facebook.svg';
import TwitterSvg from '../../../assets/svg/twitter.svg';
import InstagrammSvg from '../../../assets/svg/instagramm.svg';
import YoutubeSvg from '../../../assets/svg/youtube.svg';
import PhoneSvg from '../../../assets/svg/phone.svg';
import LetterSvg from '../../../assets/svg/letter.svg';
import GlobeSvg from '../../../assets/svg/globe.svg';
import PinSvg from '../../../assets/svg/location-pin.svg';
import {videoPlyr} from "@common/plyrHelper";
import {ArrayHelpers} from '@common/ArrayHelpers';
import {EventBus} from '@common/EventBus';
import {Modal} from "@common/Modal";
import {process as processText} from '@common/MessageProcessor';
import AnalyticsUsers from "@share/catalog/components/AnalyticsUsers.vue";
import {AnalyticsHelper} from "@share/catalog/helpers/AnalyticsHelper";
import {PartnerTabs, PartnerTabs as PartnerTabsEnum} from "@share/catalog/enums/PartnerTabs";
import PartnersTabs from "@share/catalog/components/PartnersTabs.vue";
import E404 from "@service/views/errors/e404.vue";
import ObjectSidebar from "@share/object-sidebar/ObjectSidebar.vue";
import ContactsAgreement from "@share/common/contacts-agreement/ContactsAgreement.vue";
import { keepRatio } from "@common/aspectRatioHelper";
import { getYouTubeUrl } from "@common/urlHelper";
import { WebinarInfoHelper } from "../helpers/WebinarInfoHelper";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { getImageUrl } from "@common/ImageUrlHelper";
import { getIgnoringQueryObject } from "@service/helpers/exclusionGroupHelper";
import { mainActions } from "@service/store/main/actions";
import { renderDescription } from "@share/catalog/helpers/DescriptionGenerator";
import { SocialNetworks } from "@share/catalog/enums/SocialNetworks";
import { ContactsTypes } from "@share/catalog/enums/ContactTypes";
import { MultiLanguageObject } from "@api/models/objects/MultiLanguageObject";
import LangSelector from "@share/common/controls/lang-selector/LangSelector.vue";
import { createLanguageService, LanguagesService } from "@share/common/services/LanguagesService";
import { SchemaSettings } from "@api/models/objects/SchemaSettings";
import { ObjectsService } from "@share/common/services/ObjectsService";
import { exhibitionConverter } from "@api/models/objects/Converters";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { ObjectResetter } from "@share/common/helpers/ObjectResetter";

import { PartnerDataLoader } from "@share/catalog/services/PartnerDataLoader"

@Component({
        components: {
            ObjectSidebar,
            PartnersTabs,
            AnalyticsUsers, LangSelector,
            PeopleManagement, FileUploadPlaceholder, TextFieldPlaceholder, ParticipantsPlaceholder, VideoPlaceholder,
            WebConference, Comments, ItemsList, Speaker, Description, ContactsAgreement, E404,
            BounceSpinner, Overlay, CheckSvg, LiveSvg, ObjectLayout, PlayBtn, TagList, ImageCard, Analytics, FileSvg,
            LinkedinSvg, FacebookSvg, TwitterSvg, InstagrammSvg, YoutubeSvg, PhoneSvg, LetterSvg, GlobeSvg, PinSvg, PdfSvg }
    })
    export default class Partner extends Mixins(CatalogMixin, OnlineCounter, AnalyticsMixin) {
        isLoading = true;
        userRepository: UserRepository ;
        fileRepository: FileRepository = this.$repositories.get(RepositoryFabric.FILE);
        speakers: UserProfile[] = [];
        item: GeneralCatalogItem | null = null;
        webinarInfo: WebinarInfo | null = null;
        clickedAt: DateTime | null = null; // время нажатия на кнопку Мне интересно
        now: DateTime | null = null; // текущее время для проверки доступности нажатия кнопки Мне интересно (не чаще раза в 10 минут)
        timerId =  0;
        plyr: any = null;
        contentPlyr: any = null;
        isVideoPlaying = false;
        pauseTimerId = 0; // таймер для скрытия плеера при приходе события pause, сразу скрывать не можем, т.к. перемотка видео тоже вызывает событие pause
        recommendedItems: GeneralCatalogItem[] = []; // рекомендованные элементы при отображении медиа

        isUpdating = false;
        changes: Record<string, any> = {};
        files: AppercodeFile[] = [];
        socialNetworks: Record<string, string>[] = [];
        contacts: Record<string, string>[] = [];
        brickClasses = ['description-brick1', 'description-brick2', 'description-brick3']; // названия классов, которые будут прописываться блокам при сохранении поля description
        //MOVE:
        generateBlockRegExp = (brickClass: string) => `<div class="[^"]*?${brickClass}[^"]*?">((.|\n)*?)</div>`; // функция генерации RegExp'а для поиска блока в поле description
        analyticsHelper: AnalyticsHelper | null = null;
        activeTab: PartnerTabsEnum = PartnerTabsEnum.Home;
        playerResizeObserver: ResizeObserver | null = null;
        showContactsAgreement = true;
        imageExtensions = ['png', 'jpg', 'jpeg'];
        localEditing = false;
        readonly descriptionKeyName = 'webClientDescription';

        editModel: MultiLanguageObject<GeneralCatalogItem> | null = null;
        languagesService: LanguagesService | null = null;
        objectsService: ObjectsService | null = null;
        objectResetter: ObjectResetter | null = null;

        dataLoader: PartnerDataLoader;

        validationErrors = {
            title: {
                required: {} as Record<string, boolean>
            },
            iconFile: {
                required: false
            }
        }

        created() {
            this.dataLoader = new PartnerDataLoader(
                this.schemaId,
                this.objectRepository,
                this.$repositories.get(RepositoryFabric.MEETING) as MeetingRepository,
                this.$repositories.get(RepositoryFabric.USER) as UserRepository
            );
        }

        async mounted() {
            this.socialNetworks = [
                { name: SocialNetworks.linkedin, icon: 'LinkedinSvg', placeholder: this.$t('exhibition.socialLinkPlaceholder').toString() },
                { name: SocialNetworks.facebook, icon: 'FacebookSvg', placeholder: this.$t('exhibition.socialLinkPlaceholder').toString() },
                { name: SocialNetworks.twitter, icon: 'TwitterSvg', placeholder: this.$t('exhibition.socialLinkPlaceholder').toString() },
                { name: SocialNetworks.instagramm, icon: 'InstagrammSvg', placeholder: this.$t('exhibition.socialLinkPlaceholder').toString() },
                { name: SocialNetworks.youtube, icon: 'YoutubeSvg', placeholder: this.$t('exhibition.socialLinkPlaceholder').toString() },
            ];

            this.contacts = [
                { name: ContactsTypes.phoneNumber, icon: 'PhoneSvg', placeholder: this.$t('exhibition.phoneNumberPlaceholder').toString() },
                { name: ContactsTypes.email, icon: 'LetterSvg', placeholder: this.$t('exhibition.emailPlaceholder').toString() },
                { name: ContactsTypes.site, icon: 'GlobeSvg', placeholder: this.$t('exhibition.sitePlaceholder').toString() },
                { name: ContactsTypes.address, icon: 'PinSvg', placeholder: this.$t('exhibition.addressPlaceholder').toString() },
            ];

            this.analyticsHelper = new AnalyticsHelper(this);

            await this.fetchItem();
            await this.fetchFiles();
            if (!this.isGeneralCatalog) {
                this.fetchRecommendedItems();
            }
            await this.fetchWebinar();

            this.now = DateTime.local();

            const fromLs = localStorage.getItem(this.lsKey);
            if (fromLs) {
                this.clickedAt = DateTime.fromISO(fromLs);
                this.runTimer();
            }

            await this.fetchUserProfiles();

            this.isLoading = false;

            if (this.isLive) {
                this.subscribeToOnlineUsersUpdate();
            }

            if(this.youTube || this.custom || this.linkToVideo) {
                this.loadVideo()
            }

            if(!this.isGeneralCatalog) {
                this.$nextTick(() => {
                    this.setResizeObserver()
                })
            }

            //subjects for edit multilanguage fields
            this.objectsService = new ObjectsService(
                this.$repositories.get<ObjectRepository>(RepositoryFabric.OBJECT),
                this.$store
            );
            this.languagesService = await createLanguageService(this.$store);

            const schemaSettings = GeneralCatalogItem.getSchemaSettings(this.schemaId);
            const [item] = await this.initDataLoader(schemaSettings);

            if(item) {
                this.editModel = new MultiLanguageObject<GeneralCatalogItem>(this.languagesService, item, schemaSettings);
                this.objectResetter = new ObjectResetter(this.editModel.data);
            }
        }

        async initDataLoader(schemaSettings: SchemaSettings<GeneralCatalogItem>) {
            try {
                return await Promise.all([
                    this.objectsService?.getDataForAllLanguages<GeneralCatalogItem>({
                        schema: this.schemaId,
                        objectId: this.itemId,
                        converter: exhibitionConverter,
                        include: GeneralCatalogItem.FillableFields,
                        schemaSettings: schemaSettings
                    }, this.languagesService?.list || [])
                ]);
            }
            catch (e) {
                await this.$store.dispatch('reportException', e);
                return [null];
            }
        }

        destroyed() {
            this.unsubscribeFromOnlineUsersUpdate();
            this.stopTimer();
            this.playerResizeObserver?.disconnect();
        }

        setResizeObserver() {
            const video = this.$refs['header-video-container'] as HTMLElement;
            if(video && ResizeObserver) {
                this.playerResizeObserver = new ResizeObserver(this.keepVideoRation);
                this.playerResizeObserver.observe(video);
            }
        }

        @Watch('itemId')
        private async onObjectIdChange() {
            if (this.itemId) {
                this.speakers = [];
                this.files = [];
                await this.fetchItem();
                await this.fetchUserProfiles();
                await this.fetchRecommendedItems();
                await this.fetchFiles();
                this.playerResizeObserver?.disconnect();
                (this.$refs['header-video-container'] as HTMLElement).innerHTML ='';
                this.loadVideo();
                this.$nextTick(() => {
                    this.setResizeObserver()
                });
                this.showContactsAgreement = true;
            }
        }

        private openItem(item: GeneralCatalogItem | null) {
            if (item) {
                this.$router.push({
                    name: 'Partner',
                    params: {
                        ...this.$route.params,
                        id: item.id
                    }
                });
            }
        }

        showChat(item: UserProfile) {
            EventBus.$emit("showChatByUserId", item.userId)
        }

        playVideo() {
            this.isVideoPlaying = true;
            if (!this.showWebConference) {
              const container = this.$refs["header-video-container"] as HTMLElement,
                  parent = container.parentElement!;
              parent.style.visibility = 'visible';
              this.plyr?.play();
            }
            else {
                this.$store.dispatch("miniPlayer/pauseVideo");
            }
        }

        pauseVideo() {
            this.isVideoPlaying = false;
            const container = this.$refs["header-video-container"] as HTMLElement,
                parent = container.parentElement!;
            parent.style.visibility = 'hidden';
        }

        //MOVE:
        parseLink(link: string) {
            if (link && !/^(?:f|ht)tps?:\/\//.test(link)) {
                link = "https://" + link;
            }
            return link || "";
        }

        close() {
            this.$emit('closed');
        }

        // data loading
        async fetchItem() {
            if(!this.itemId) {return;}

            try {
                const item = await this.dataLoader.getItem(this.itemId, this.$store.state.session.profile?.groupIds || []);

                if(item) {
                    this.item = item;

                    if(!this.isLive && item) {
                        const webinarInfo = WebinarInfoHelper.getWebinarInfo(item);
                        this.webinarInfo = webinarInfo ? webinarInfo : this.webinarInfo;
                    }

                    this.sendScreenView(`${this.schemaId} - ${this.item.title || this.item.id}`, this.itemId, this.schemaId);
                    this.$emit("setPageTitle", this.item.title)
                }
            }
            catch (e) {
                this.$store.dispatch('reportError', e);
            }
        }

        async fetchWebinar() {
            if (this.isLive) {
                try {
                    this.webinarInfo = await this.dataLoader.getWebinar(this.itemId);
                }
                catch (e) {
                    this.$store.dispatch('reportError', e);
                }
            }
        }

        async fetchRecommendedItems() {
            try {
                this.recommendedItems = await this.dataLoader.getRecommendedItems({
                    id: this.item?.id,
                    parentId: this.item?.parentId,
                    groups: this.$store.state.session.profile?.groupIds || [],
                    eventId: this.$store.getters['events/selectedEvent']?.id
                });

                console.log(this.recommendedItems, "this.recommendedItems");
            }
            catch(e) {
                this.$store.dispatch('reportError', e);
            }
        }

        async fetchUserProfiles() {
            if (this.item?.userProfileIds?.length) {
                try {
                    const speakers = await this.dataLoader.getUserProfiles(this.item.userProfileIds, this.$store.getters['ignoredUserGroupIds']);
                    const speakersById = ArrayHelpers.keyBy(speakers, 'id');

                    //TODO: rename this field - they are no speakers
                    this.speakers = this.item.userProfileIds.map((id: string) => speakersById[id]).filter(item => item);
                }
                catch (e) {
                   this.$store.dispatch('reportError', e);
                }
            }
        }

        async fetchFiles() {
            //TODO: use the file helper or something else
            if (this.item?.fileIds){
                this.files = await Promise.all(this.item.fileIds.map(async file => this.fileRepository.get(file)))
            }
        }

        get singleLangDisabled() {
            return this.languagesService && !this.languagesService.isSelectedLanguageBase && this.isEditing;
        }

        get onlineUsersCounterId() {
            return `${this.schemaId}/${this.itemId}`;
        }

        get modalItemState() {
            const element = this.$store.getters['formModal/openElementById'](this.itemId);
            return element && element.state;
        }

        get image(): string {
            //setting null for delete in editor
            if (this.changes.imageFileUrl || this.changes.imageFileUrl === null) {
                return this.changes.imageFileUrl;
            }
            return getImageUrl(this.$store.state.session.backend, this.item?.bannerFileId, 1980);
        }

        get headerYoutubeLink(): string {
            if (this.changes.headerYoutubeLink) {
                return this.changes.headerYoutubeLink;
            }
            return this.youTube ? this.youTube?.iframeUrl ?? '' : '';
        }

        get icon(): string {
            //setting null for delete in editor
            if (this.changes.iconFileUrl || this.changes.iconFileUrl === null) {
                return this.changes.iconFileUrl;
            }
            return getImageUrl(this.$store.state.session.backend, this.item?.iconFileId, 512);
        }

        set title(value: string) {
            this.editModel && (this.editModel.localizedData.title = value);
        }

        get title(): string {
            return this.editModel?.localizedData.title || "";
        }

        setDesciption(fieldName: string, value: string) {
            /**
             * 1. We need to convert current @description string value to cleared strings @list
             * 2. After we nedd update @list by @index
             * 3. Convert list back to @description string value
             */

            const [propName, index] = fieldName.split(':');

            const descriptionValue = this.editModel?.localizedData?.[propName] ?? "";


            if (typeof descriptionValue === "string") {
                // 1----
                const descriptions = this.convertDescriptionToList(descriptionValue);

                // 2----
                descriptions[+index] = value;

                // 3-----
                const data = this.editModel?.localizedData;
                if(data) {
                    data[propName] = descriptions
                            .map((item: string, index: number) => `<div class="${this.brickClasses[index]}">${item}</div>`)
                            .join('')
                }
            }
        }

        get editedDescription(): string[] {
            const source = this.editModel?.localizedData[this.descriptionKeyName] ?? ''
            return this.convertDescriptionToList(source);
        }

        get description(): string[] {
            const source = this.item?.[this.descriptionKeyName] ?? '';
            return this.convertDescriptionToList(source);
        }

        /**
         * convert html-string value of @description to list of cleaned values
         */
        convertDescriptionToList(source: string) {
            //MOVE:
            let bricksFounded = false;

            const bricks = this.brickClasses.map((brick) => {
                const match = source.match(new RegExp(this.generateBlockRegExp(brick), 'm'));
                if (match) {
                    bricksFounded = true;
                }
                return match ? match[1] : '';
            });
            return (bricks.some(item => item) || bricksFounded) ? bricks : this.brickClasses.map((_, index) => index === 0 ? source : '');
        }

        get linkToVideo(): string {
            if (this.changes.links?.linkToVideo !== undefined) {
                return this.changes.links.linkToVideo;
            }
            return this.item?.links?.linkToVideo ? this.item?.links?.linkToVideo : '';
        }

        get fileList(): (AppercodeFile | File)[] {
            if (!this.isGeneralCatalog) {
                return this.files;
            }

            //MOVE: maybe
            const result = [];
            for(let i = 0; i <= 2; i++) {
                if (this.changes.files?.[i]) {
                    if(this.changes.files[i].isDeleted) {
                        result.push(null);
                    }
                    else {
                        result.push(this.changes.files[i]);
                    }
                } else if (this.files?.[i]) {
                    result.push(this.files[i]);
                } else {
                    result.push(null);
                }
            }
            return this.isEditing ? result : result.filter(item => item);
        }

        get availableNetworks() {
            const mappedNetworks = this.socialNetworks
                .map(network => Object.assign({}, network, {
                    link: this.changes?.links?.[network.name] ?? (this.item?.links?.[network.name] || '')
                }));
            if (this.isEditing) {
                return mappedNetworks;
            }
            return mappedNetworks.filter((network) => this.item?.links?.[network.name]);
        }

        get availableContacts() {
            const mappedContacts = this.contacts
                .map(contact => Object.assign({}, contact, {
                    link: this.changes?.links?.[contact.name] ?? (this.item?.links?.[contact.name] || '')
                }));
            if (this.isEditing) {
                return mappedContacts;
            }
            return mappedContacts.filter((contact) => this.item?.links?.[contact.name]);
        }

        get bottomImage() {
            if (this.changes.bottomImageFileUrl || this.changes.bottomImageFileUrl === null) {
                return this.changes.bottomImageFileUrl;
            }
            return getImageUrl(this.$store.state.session.backend, this.item?.links?.bottomImageFileId, 1980);
        }

        get isLive() {
            return this.item?.isOnline;
        }

        get webConference() {
          return this.webinarInfo?.onlineProvider == OnlineProvider.webConference;
        }

        get youTube() {
            return this.webinarInfo?.youTube && Object.keys(this.webinarInfo.youTube).length > 0 ? this.webinarInfo?.youTube : '';
        }

        get custom() {
            return this.webinarInfo?.custom && Object.keys(this.webinarInfo.custom).length > 0 ? this.webinarInfo?.custom : '';
        }

        get showPartnerVideo() {
            return Boolean(this.youTube && this.youTube.url || this.custom)
        }

        get showPlayBtn(): boolean {
          return !this.isEditing && !this.isVideoPlaying && Boolean(this.showPartnerVideo || this.webConference);
        }

        get showWebConference(): boolean {
          return this.isVideoPlaying && this.webConference;
        }

        get isAdmin() {
          return this.$store.getters['isAdmin'];
        }

        get showPeopleManagement() {
            return this.isAdmin && this.showWebConference;
        }

        // была ли кнопка Мне интересно уже нажата
        get hasClicked() {
            if (this.clickedAt && this.now) {
                const result = this.now.diff(this.clickedAt, 'minutes').minutes <= 10;
                if (!result) {
                    localStorage.removeItem(this.lsKey);
                    this.clickedAt = null;
                    this.stopTimer();
                }
                return result;
            }
            return false;
        }

        // ключ для localStorage
        get lsKey() {
            return this.$store.state.session.backend + '_catalog_' + this.item?.id + '_' + this.userId;
        }

        get userId() {
            return this.$store.state.session.userId;
        }

        get userProfile() {
            return this.$store.getters.profile;
        }

        // можно администрировать, если ты указан в ownerIds стенда
        get isPartnerOwner() {
            return this.ownerUserIds.includes(this.userId);
        }

        get usersForEditing() {
            if (this.changes.userProfileIds) {
                const speakersById = ArrayHelpers.keyBy(this.speakers, 'id');
                return this.changes.userProfileIds.map((id: string) => speakersById[id]);
            }

            return this.speakers;
        }

        get isHomeActive() {
          return this.activeTab === PartnerTabs.Home;
        }

        get isDashboardActive() {
            return this.activeTab === PartnerTabs.Dashboard;
        }

        get isVisitorsActive() {
            return this.activeTab === PartnerTabs.Visitors;
        }

        get showSpinner() {
            return this.isLoading || this.isUpdating || this.analyticsHelper?.isFetchingAnalytics;
        }

        get ownerUserIds() {
            return this.item?.ownerIds ?? [];
        }

        get showIAmInterestingButton() {
            const currentUserIsOwner = this.ownerUserIds.some((ownerUserId) => ownerUserId === this.userId);

            return !currentUserIsOwner;
        }

        // helpers

        youTubeUrl(url: string) {
            return getYouTubeUrl(url);
        }

        async initializeVideo(refName: string, syncMaxHeight = false) {
            if (this.isLive) { // нужно ли поддерживать live в партнере?
                return null;
            }

            await this.$nextTick();

            let plyr = null;
            if (this.$refs[refName]) {
                plyr = videoPlyr((this.$refs[refName] as HTMLElement).querySelector('div'), { clickToPlay: false, fullscreen: { enabled: true } });
                if (this.isGeneralCatalog) {
                    if (syncMaxHeight) {
                        plyr.on('ready', () => { this.adjustVideoRatio(refName, true) });
                        plyr.on('enterfullscreen', () => { this.adjustVideoRatio(refName, false) });
                        plyr.on('exitfullscreen', () => { this.adjustVideoRatio(refName, true) });
                    }
                    plyr.on('pause', () => { this.pauseTimerId = window.setTimeout(() => { this.pauseVideo() }, 300) });
                    plyr.on('play', () => {
                        this.$store.dispatch("miniPlayer/pauseVideo");
                        if (this.pauseTimerId) {
                            window.clearTimeout(this.pauseTimerId);
                            this.pauseTimerId = 0;
                        }
                    });
                }
            }

            return plyr;
        }

        keepVideoRation() {
            let fixContainer = this.$refs["video-fix-container"] as HTMLElement;

            if(fixContainer) {
                keepRatio(fixContainer);
            }
        }

        adjustVideoRatio(refName: string, restrictMaxheight = true) {
            //MOVE:
            const container = this.$refs[refName] as HTMLElement,
                parent = container.parentElement!,
                frame = container.querySelector('.plyr__video-wrapper iframe') as HTMLElement;

            if (frame) {
                if (restrictMaxheight) {
                    parent.style.height = '100%';

                    let height = parent.clientHeight,
                        width = height * 16 / 9;

                    if (parent && parent.clientWidth < width) {
                        width = parent.clientWidth;
                        height = (width * 9) / 16;
                    }

                    frame.style.width = width + 'px';
                    frame.style.height = height + 'px';
                    container.style.height = height + 'px';
                    container.style.width = width + 'px';
                } else {
                    frame.style.width = '100%';
                    frame.style.height = '';
                    container.style.width = '100%';
                    container.style.height = '';
                }
            }
        }

        putToLocalStorage() {
            const date = DateTime.local();
            localStorage.setItem(this.lsKey, date.toISO());
            this.clickedAt = date;
            this.runTimer();
        }

        fileName(fileUrl: string) {
            return (fileUrl.match(/([^.]+)\..+/) || ['', ''])[1];
        }

        linkToFile(file: AppercodeFile) {
            return getImageUrl(this.$store.state.session.backend, file?.id, undefined, file.name);
        }

        linkToContact(contact: Record<string, string>) {
            // MOVE:
            switch (contact.name) {
                case 'email':
                    return `mailto:${contact.link}`;
                case 'site':
                    return contact.link.startsWith('https://') || contact.link.startsWith('http://')
                        ? contact.link
                        : `https://${contact.link}`;
                case 'phoneNumber':
                    return `tel:${contact.link}`;
            }

            return '';
        }

        async uploadImage(imageType: string) {
            // TODO: need to think about file service of search it in project
            //TOSERVICE:
            const file = await this.fileRepository.create(this.changes[`${imageType}File`], `partner-${imageType}-${this.itemId}`);

            Vue.delete(this.changes, `${imageType}File`);
            window.URL.revokeObjectURL(this.changes[`${imageType}FileUrl`]);
            Vue.delete(this.changes, `${imageType}FileUrl`);

            return file.id;
        }

        processText(text: string) {
            return processText(text);
        }

        // event handlers

        async onClickIAmInteresting() {

            if (this.showIAmInterestingButton && !this.hasClicked && this.item) {
                const title = `${this.userProfile.firstName} ${this.userProfile.lastName}, ${this.item.title}`;
                const result: any = await this.$store.dispatch('chat/messageToGroupChat', {
                    title,
                    message: this.$t('exhibition.intoItMessage').toString(),
                    membersUserIds: this.ownerUserIds,
                });
                if (result) {
                    this.putToLocalStorage();
                }
            }
        }

        switchToRead() {
            this.$store.dispatch(mainActions.offIsOnEditing);
            this.localEditing = false;
        }

        async onHomeClicked() {
            if (!Object.keys(this.changes).length) {
                this.switchToRead();
                return;
            }

            const modal = new Modal({
                title: this.$t('common.warningTitle').toString(),
                contentText: this.$t('exhibition.leaveEditor').toString(),
                buttons: [
                    {
                        text: this.$t('common.yes').toString(),
                        class: 'is-red',
                        returnValue: true
                    },
                    {
                        text: this.$t('common.no').toString(),
                        class: 'is-green is-outlined',
                        returnValue: false
                    },
                ]
            });

            const confirmResult = await modal.showConfirm();
            if (confirmResult === true) {
                this.onReset();
                this.switchToRead();
            }
        }

        async onAnalyticsTabClick() {
            if (!this.analyticsHelper?.isAnalyticsFetched) {
                await this.analyticsHelper?.fetch();
            }
        }

        onReset() {
            this.changes?.imageFileUrl && window.URL.revokeObjectURL(this.changes.imageFileUrl);
            this.changes?.iconFileUrl && window.URL.revokeObjectURL(this.changes.iconFileUrl);

            //reseting data from changes
            Vue.set(this, 'changes', {});

            //reseting data from editModel
            if(this.objectResetter) {
                this.objectResetter.needToReset = true
                this.objectResetter?.reset();
            }
        }

        get invalidlangs() {
            const langList = this.languagesService?.list || [];
            const invalidLangList = [];

            if(langList.length) {
                for (const lang of langList) {
                    if(this.validationErrors.title.required[lang]) {
                        invalidLangList.push(lang);
                    }
                }
            }

            return invalidLangList;
        }

        validate() {

            let isValid = true;

            //LOGO:
            {
                const logoExist = this.changes.iconFile || this.icon;

                this.validationErrors.iconFile.required = !logoExist;

                if(!logoExist) {
                    isValid = false;
                }
            }

            //TITLE:
            {
                const langList = this.languagesService?.list || [];

                if(langList.length) {
                    for (const lang of langList) {
                        Vue.set(this.validationErrors.title.required, lang, !this.editModel?.data[lang].title);

                        if(!this.editModel?.data[lang].title) {
                            isValid = false;
                        }
                    }
                }
            }

            return isValid;
        }

        async onSave(): Promise<void> {
            const changesToSave: Record<string, any> = {};
            try {

                const valid = this.validate();

                if(!valid) {return;}

                this.isUpdating = true;

                //image file
                if (Object.prototype.hasOwnProperty.call(this.changes, 'imageFile')) {
                    if(this.changes.imageFile) {
                        changesToSave.bannerFileId = await this.uploadImage('image');
                    }
                    else {
                        changesToSave.bannerFileId = null;
                    }
                }

                //icon file
                if (Object.prototype.hasOwnProperty.call(this.changes, 'iconFile')) {
                    if(this.changes.iconFile) {
                        changesToSave.iconFileId = await this.uploadImage('icon');
                    }
                    else {
                        changesToSave.iconFileId = null;
                    }
                }
				//bottom-image file
                if (Object.prototype.hasOwnProperty.call(this.changes, 'bottomImageFile')) {
                    if (!this.changes.links) {
                        this.changes.links = {};
                    }

                    if(this.changes.bottomImageFile) {
                        this.changes.links.bottomImageFileId = await this.uploadImage('bottomImage');
                    }
                    else {
                        this.changes.links.bottomImageFileId = null;
                    }
                }

                if (this.changes.files) {
                    changesToSave.fileIds = this.item?.fileIds?.slice() || [];

                    //TODO: WHAT'S GOING ON HERE?
                    //TOSERVICE: - there is DataLoader, but this code is not about data loading, it need to move in another service
                    for(let i = 0; i < this.changes.files.length; i++) {
                        if (this.changes.files[i]) {
                            if(this.changes.files[i].isDeleted) {
                                const fileId = this.files[i]?.id
                                fileId && await this.fileRepository.delete(fileId);

                                changesToSave.fileIds = changesToSave.fileIds.filter((id: string) => id !== fileId);

                                this.files = this.files.filter(item => item.id == fileId);
                            }
                            else if (this.files[i]) {
                                const file = await this.fileRepository.upload({ id: this.files[i].id }, this.changes.files[i]);
                                const fileId = this.files[i].id;
                                if (fileId) {
                                    await this.fileRepository.update(fileId, { name: this.changes.files[i].name });
                                }
                                changesToSave.fileIds[i] = fileId;
                                const fileIndex = this.files.findIndex(item => item.id == fileId);
                                if (fileIndex > -1) {
                                    this.$set(this.files, fileIndex, file);
                                }
                            } else {
                                const file = await this.fileRepository.create(this.changes.files[i], this.changes.files[i].name, '', {READ: true, [`WRITE.user.${this.userId}`]: true});
                                changesToSave.fileIds.push(file.id);
                                this.files.push(file);
                            }
                        }
                    }
                }

                if (this.changes.links) {
                    changesToSave.links = Object.assign({}, this.item?.links || {}, this.changes.links);
                }

                if (this.changes.headerYoutubeLink !== undefined) {
                    changesToSave.onlineParams = Object.assign({}, this.item?.onlineParams || {}, {
                        youTube: {
                            url: this.changes.headerYoutubeLink
                        }
                    });
                }

                Object.keys(this.changes).forEach(key => {
                    // копируем только нужные нам поля для отправки на бекенд

                    if(['userProfileIds'].includes(key)) {
                        const userIds = (this.usersForEditing as UserProfile[]).map((userProfile) => userProfile.userId)

                        changesToSave[key] = this.changes[key] as UserProfile[]
                        changesToSave['ownerIds'] = userIds
                    }
                });

                changesToSave.isPublished = true;

                if(this.editModel) {

                    if(this.languagesService?.list) {

                        //we need to create rendered description for all languages
                        for (const lang of this.languagesService.list) {
                            this.editModel.data[lang].description = renderDescription(this.editModel.data[lang] as GeneralCatalogItem, changesToSave, this.files, lang);
                        }
                    }

                    if (Object.keys(changesToSave).length) {
                        const object = changesToSave

                        for (const key in object) {
                            if (Object.prototype.hasOwnProperty.call(object, key)) {
                                const element = object[key];
                                this.editModel.base[key] = element;
                            }
                        }
                    }

                    await this.objectsService?.update(this.schemaId, this.itemId, this.editModel);
                }

                await this.fetchItem();
                await this.fetchUserProfiles();
                await this.fetchFiles();
                this.unloadYouTubeVideo();
                this.loadYoutubeVideo();
                this.loadContentYoutubeVideo();

                Vue.set(this, 'changes', {});

                this.switchToRead();

                this.languagesService?.setSelectedLanguage(this.languagesService?.baseLanguage);
            } catch(e) {
                this.showErrorMessage(e.toString());
                this.$store.dispatch('reportError', e);
            } finally {
                this.isUpdating = false;
            }
        }

        showErrorMessage(msg: string, title: string = this.$t('exhibition.saving error').toString()) {
            const modal = new Modal({
                title: title,
                contentText: msg,
                buttons: [
                    {
                        text: this.$t('common.close').toString(),
                        class: 'is-green is-outlined',
                        returnValue: false
                    }
                ]
            });

            modal.showModal();
        }

        onExtInvalid(currentExtension: string, allowedExts: string[]) {

            const currentExtensionMessage = `${this.$t("exhibition.currentExtension").toString()}: ${currentExtension}`;
            const message = `${currentExtensionMessage} <br> ${this.$t("exhibition.availableExtensions").toString()}: ${allowedExts.join(", ")}`;

            this.showErrorMessage(message, this.$t("exhibition.wrongFileExtension", { file: this.$t("common.file").toString().toLowerCase() }).toString())
        }

        onFileSelected(file: File, fileType: string, index = 0) {
            if (this.changes[`${fileType}Url`]) {
                window.URL.revokeObjectURL(this.changes[`${fileType}Url`]);
            }

            if (fileType === 'file') {
                if (!this.changes.files) {
                    Vue.set(this.changes, 'files', [null, null, null]);
                }
                if(!file) {
                    const copiedFile = {...this.files[index]};
                    copiedFile.isDeleted = true;
                    Vue.set(this.changes.files, index, copiedFile);
                }
                else {
                    Vue.set(this.changes.files, index, file);
                }
            } else {
                Vue.set(this.changes, fileType, file);
            }

            if (['iconFile', 'imageFile', 'bottomImageFile'].includes(fileType)) {
				//set null if deleted
                Vue.set(this.changes, `${fileType}Url`, this.changes[fileType] && window.URL.createObjectURL(this.changes[fileType]) || null);
            }
        }

        onYouTubeLinkChanged(fieldName: string, value: string) {
            if (this.item?.[fieldName] !== value) {
                Vue.set(this.changes, fieldName, value);
            }
        }

        onLinksChanged(attributeName: string, value: string) {
            if (this.item?.links?.[attributeName] !== value) {
                if (!this.changes.links) {
                    Vue.set(this.changes, 'links', {});
                }
                Vue.set(this.changes.links, attributeName, value);
            }
        }

        onContactsEdited(value: string[]) {
            Vue.set(this.changes, 'userProfileIds', value);
        }

        runTimer() {
            this.timerId = window.setInterval(() => {
                if (this.now) {
                    const date = DateTime.local();
                    if (date.diff(this.now, ['minutes']).minutes >= 1) {
                        this.now = date;
                    }
                }
            }, 1000);
        }

        stopTimer() {
            clearInterval(this.timerId);
        }

        loadVideo() {
            if (this.webinarInfo?.youTube.iframeUrl) {
                this.loadYoutubeVideo()
            }
            else if(this.webinarInfo?.custom.url) {
                this.loadCustomVideo();
            }
            if (this.linkToVideo) {
                this.loadContentYoutubeVideo();
            }
        }

        unloadYouTubeVideo() {
            if (this.plyr) {
                (this.$refs['header-video-container'] as HTMLElement).innerHTML ='';
                this.plyr.destroy();
            }
            if (this.contentPlyr) {
                (this.$refs['content-video-container'] as HTMLElement).innerHTML ='';
                this.contentPlyr.destroy();
            }
        }

        async loadYoutubeVideo() {
            if (this.webinarInfo?.youTube.iframeUrl) {
                this.createPlyrDiv('header-video-container', this.webinarInfo?.youTube.iframeUrl ?? this.webinarInfo?.custom.url ?? '');
                this.plyr = await this.initializeVideo('header-video-container', true);
            }
        }

        createPlyrDiv(refName: string, iframeSrc: string) {
            const div = document.createElement('div'),
                iframe = document.createElement('iframe');
            iframe.src = iframeSrc;

            this.$nextTick(() => {
                (this.$refs[refName] as HTMLElement)?.appendChild(div);
                // if inside first children of this.$refs['video-container'], iframe is not exist, then ->
                if(!(this.$refs[refName] as HTMLElement).querySelector('div')?.querySelector('iframe')) {
                    div.appendChild(iframe);
                }
            });
        }

        loadCustomVideo() {
            if(this.webinarInfo?.custom.url) {
                this.createIframe();
            }
        }

        createIframe() {
            const div = document.createElement('div');
            const iframe = document.createElement('iframe');

            div.appendChild(iframe);
            div.classList.add('partner__custom-video-container')

            iframe.src = this.webinarInfo?.custom.url ?? '';
            this.$nextTick(() => {
                (this.$refs['header-video-container'] as HTMLElement).appendChild(div)
            });
        }

        async loadContentYoutubeVideo() {
            if (this.linkToVideo) {
                this.createPlyrDiv('content-video-container', this.linkToVideo);
                this.contentPlyr = await this.initializeVideo('content-video-container');
            }
        }

        async onActiveTabChanged(tab: PartnerTabsEnum) {
            switch (tab) {
                case PartnerTabs.Home:
                    await this.onHomeClicked();
                break;
                case PartnerTabs.Dashboard:
                case PartnerTabs.Visitors:
                    await this.onAnalyticsTabClick();
                break;
            }
        }

        fileIconByType(file: AppercodeFile) {
            const nameParts = file.name.split('.');
            const extension = nameParts[nameParts.length - 1];

            switch (extension) {
                case 'pdf':
                    return PdfSvg;
                default:
                    return FileSvg;
            }
        }

        get isEditing() {
            return this.$store.state.isOnEditing || this.localEditing
        }
    }
